import { EventEmitter } from '@angular/core';
import { PredictiveSearch } from '@com-delta-idp/mnx-sitewide-shared-core-ui';
import { TripTypeOptions } from '../../constants/book-widget.constants';
import { BookWidgetAem } from '../../models/book-widget-aem.interfaces';
import { InfoPopUpContent } from '../common/info-popup-modal/models/info-popup-modal.interface';

export class HomeBookWidgetExtendedComponent {
  bookWidgetAem?: BookWidgetAem | null;
  viewSearchOptionEvent = new EventEmitter();
  tripTypeOptions = TripTypeOptions;
  infoPopUpModalData = {} as InfoPopUpContent;
  isAdvancedSearchExpanded = false;

  protected predictiveSearchData: PredictiveSearch = {
    placeholder: '',
    items: [],
    title: '',
    value: '',
    transparentSearch: true,
    errorMessage: '',
    selectLabel: ''
  };

  protected showDialog = false;

  preparePlaceholderText(type: string) {
    let placeholder = this.bookWidgetAem?.airportsField.searchModal.originLabel;

    if (type === 'destination') {
      placeholder =
        this.bookWidgetAem?.airportsField.searchModal.destinationLabel;
    } else if (type === 'connection') {
      placeholder =
        this.bookWidgetAem?.airportsField.searchModal.connectionAirportLabel;
    }

    return placeholder || '';
  }

  onViewSearchOptionsHandler() {
    this.viewSearchOptionEvent.emit();
  }
}
